export const sportsIconMap: Record<string, string | null> = {
  Cricket: '/icons/sports/cricket-ball.webp',
  Soccer: '/icons/sports/football.webp',
  Football: '/icons/sports/football.webp',
  Tennis: '/icons/sports/tennis.webp',
  'Table Tennis': '/icons/sports/table-tennis.webp',
  Esoccer: '/icons/sports/e-soccer.webp',
  'Horse Racing': '/icons/sports/horse-racing.webp',
  'Greyhound Racing': '/icons/sports/greyhound.webp',
  Basketball: '/icons/sports/basket-ball.webp',
  Wrestling: '/icons/sports/wrestling.webp',
  Volleyball: '/icons/sports/volleyball.webp',
  Badminton: '/icons/sports/badminton.webp',
  Snooker: '/icons/sports/snooker.webp',
  Darts: '/icons/sports/dart2.webp',
  Boxing: '/icons/sports/boxing.webp',
  'Mixed Martial Arts': '/icons/sports/boxing.webp',
  'American Football': '/icons/sports/american-football.webp',
  'E Games': '/icons/sports/e-games.webp',
  'Ice Hockey': '/icons/sports/ice-hockey.webp',
  Futsal: '/icons/sports/futsal.webp',
  Politics: '/icons/sports/politics.webp',
  'Motor Sports': '/icons/sports/motor-racing.webp',
  Kabaddi: '/icons/sports/kabbadi.webp',
};

export const casinoProviders = [
  'ALL',
  'MAC88 GAMING',
  'MAC88 GAMING VIRTUAL',
  'MAC EXCITE',
  'SMARTSOFT',
  'SPRIBE',
  'EVOLUTION GAMING',
  'TURBO',
  'EZUGI',
  'JILI',
  'PLAYTECH',
  'BETSOFT',
  'GAMZIX',
  'BETGAMES',
  'EVOPLAY',
  'ASIA GAMING',
  'WINFINITY',
  'VIVOGAMING',
  'ROYAL GAMING',
];

export const gamesCategory = [
  { name: 'All', icon: null },
  { name: 'Aviator', icon: 'aviator.png' },
  { name: 'Mines', icon: 'mines.png' },
  { name: 'Color Game', icon: 'colorgame1.png' },
  { name: 'Dragon Tiger', icon: 'dragon-tiger1.png' },
  { name: 'Andar bahar', icon: 'andar-bahar1.png' },
  { name: 'Teenpatti', icon: 'teenpatti1.png' },
  { name: 'Lottery', icon: 'lottery.png' },
  { name: 'Live Lobby', icon: 'live-lobby1.png' },
  { name: 'Crash Game', icon: 'crash-game.png' },
  { name: 'Casual Game', icon: 'casual-game.png' },
  { name: 'Scratch Cards', icon: 'scratch-card.png' },
  { name: 'Live Blackjack', icon: 'live-blackjack.png' },
  { name: 'Live Baccarat', icon: 'live-bacarrat.png' },
  { name: 'Live Roulette', icon: 'live-roulette.png' },
  { name: 'Live Dice', icon: 'live-dice.png' },
  { name: 'Table', icon: 'live.png' },
  { name: 'Live', icon: 'live.png' },
  { name: 'Virtual', icon: 'live.png' },
  { name: 'Live Dealer', icon: 'live.png' },
  { name: 'Lobby', icon: 'live.png' },
  { name: 'Wheel of Fortune', icon: 'live.png' },
  { name: 'Baccarat', icon: 'live.png' },
  { name: 'Poker', icon: 'live-poker.png' },
  { name: 'Blackjack', icon: 'live-blackjack.png' },
  { name: 'Lucky7', icon: 'live.png' },
  { name: 'Roulette', icon: 'live-roulette.png' },
  { name: 'Sicbo', icon: 'live.png' },
  { name: 'Casual Games', icon: 'casual-game.png' },
  { name: 'Slot games', icon: 'slots.png' },
  { name: 'Bingo', icon: 'bingo.png' },
  { name: 'Hi Lo', icon: 'hi_low.png' },
  { name: 'Deal Or No Deal', icon: 'dealornodeal.png' },
  { name: 'Rummy', icon: 'rummy.png' },
  { name: 'Plinko', icon: 'live-sic-bo.png' },
  { name: 'Others', icon: 'others.png' },
];

export const categoryIconMap: Record<string, string> = {
  'Casual Games': '/images/casino/category/casual-game.svg',
  'Crash Games': '/images/casino/category/crash-game.svg',
  'Slot Games': '/images/casino/category/slot-game.svg',
  'Slot games': '/images/casino/category/slot-game.svg',
  'Video Slots': '/images/casino/category/slot-game.svg',
  Virtual: '/images/casino/category/slot-game.svg',
  Virtuals: '/images/casino/category/slot-game.svg',
  'Game Shows': '/images/casino/category/live-lobby.svg',
  'Game Show': '/images/casino/category/live-lobby.svg',
  Live: '/images/casino/category/live-lobby.svg',
  'Live Game Shows': '/images/casino/category/live-lobby.svg',

  'Live Roulette': '/images/casino/category/live-roulette.svg',
  'Live Lobby': '/images/casino/category/live-lobby.svg',
  'Live Poker': '/images/casino/category/live-poker.svg',
  'Live Blackjack': '/images/casino/category/live-blackjack.svg',
  'Live Baccarat': '/images/casino/category/live-baccarat.svg',
  'Live Dice': '/images/casino/category/live-dice.svg',
  'Live Crash': '/images/casino/category/crash-game.svg',
  'Live Dragon Tiger': '/images/casino/category/dragon-tiger.svg',
  'Dragon Tiger': '/images/casino/category/dragon-tiger.svg',

  andar_bahar: '/images/casino/category/andar-bahar.svg',
  Andarbahar: '/images/casino/category/andar-bahar.svg',
  Teenpatti: '/images/casino/category/teenpatti.svg',
  Lottery: '/images/casino/category/lottery.svg',
  'Live Lottery': '/images/casino/category/lottery.svg',

  Baccarat: '/images/casino/category/live-baccarat.svg',
  Blackjack: '/images/casino/category/live-blackjack.svg',
  roulette: '/images/casino/category/live-roulette.svg',
  Roulette: '/images/casino/category/live-roulette.svg',

  sicbo: '/images/casino/category/live-sic-bo.svg',
  'Live Sic Bo': '/images/casino/category/live-sic-bo.svg',
  'Live SicBo': '/images/casino/category/live-sic-bo.svg',

  Mines: '/images/casino/category/mines.svg',
  Plinko: '/images/casino/category/color-games.svg', // closest match visually (ball/drop)
  Bingo: '/images/casino/category/bingo.svg',
  'Color Games': '/images/casino/category/color-games.svg',
  Aviator: '/images/casino/category/aviator.svg',
  'Deal or No Deal': '/images/casino/category/dealornodeal.svg',
  Rummy: '/images/casino/category/rummy.svg',
  'Scratch Card': '/images/casino/category/scratch-card.svg',
  'Scratch Cards': '/images/casino/category/scratch-card.svg',

  'Table Games': '/images/casino/category/sidebarOverlay.svg',
  Table: '/images/casino/category/sidebarOverlay.svg',

  Others: '/images/casino/category/three-cards.svg',
  'Top Card': '/images/casino/category/three-cards.svg',
  Unknown: '/images/casino/category/three-cards.svg',
  'Arcade Game': '/images/casino/category/three-cards.svg',
  'Arcade Games': '/images/casino/category/three-cards.svg',
  card: '/images/casino/category/three-cards.svg',
  casino: '/images/casino/category/three-cards.svg',
  Casino: '/images/casino/category/three-cards.svg',
  'Fish Shooting': '/images/casino/category/three-cards.svg',
};
